<template>
  <Teleport defer to="ion-app">
    <ion-modal
      ref="ionModal"
      class="modal-70-height"
      :swipe-to-close="true"
      :can-dismiss="true"
      :initial-breakpoint="1"
      :breakpoints="[0, 1]"
      @didDismiss="closeModal"
      @ion-breakpoint-did-change="closeModal"
      @wheel.prevent
      @touchmove.prevent
      @scroll.prevent
    >
      <ion-content class="ion-padding">
        <div class="drag-handle"></div>
        <div class="flex flex-col gap-8 px-[8px]">
          <div
            class="text-[1.5rem] leading-[2.0625rem] font-black text-[#2B2926] tracking-[-0.03em]"
          >
            What is this information used for?
          </div>
          <div class="text-[1rem] leading-[1.5rem] font-medium text-[#433D31]">
            We use your partial NRIC to help accurately identify you when you give your tithe. This
            ensures your contributions are recorded and attributed to your account.
          </div>
          <div class="text-[1rem] leading-[1.5rem] font-medium text-[#433D31]">
            Rest assured, your information is handed securely and is only used for this purpose.
          </div>
        </div>
      </ion-content>
    </ion-modal>
  </Teleport>
</template>

<script>
import {
  IonButtons,
  IonButton,
  IonModal,
  IonHeader,
  IonToolbar,
  IonContent,
  IonTitle,
} from '@ionic/vue';
export default {
  components: {
    IonButtons,
    IonButton,
    IonModal,
    IonHeader,
    IonToolbar,
    IonContent,
    IonTitle,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.$refs.ionModal?.$el?.present();
      } else {
        this.$refs.ionModal?.$el?.dismiss();
      }
    },
  },
  mounted() {
    if (this.isOpen) {
      this.$nextTick(() => this.$refs.ionModal?.$el?.present());
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-70-height {
  --height: 85vh;
  --border-radius: 24px 24px 0 0;
  --box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  fill: rgba(93, 93, 93, 0.6);
  align-items: flex-end !important;
  transition: all 0.8s ease-in-out !important;
  .modal-wrapper {
    transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
  }
  ion-content {
    --background: #f6f4f0;
  }
}
.modal-70-height::part(content) {
  border-radius: 24px 24px 0 0;
}
.modal-70-height::part(handle) {
  display: none;
}
.drag-handle {
  width: 88px;
  height: 4px;
  background: #63615e;
  border-radius: 4px;
  margin: -8px auto 16px auto;
}
</style>
